import { useEffect, useState } from "react";
import formInputs from "./formInputs.js";
import closeIcon from "../assets/closeIcon.svg"
import expertiseSX from "./muiStyles/expertiseSX.js";
import searchSX from "./muiStyles/searchSX.js";
import searchBlankSX from "./muiStyles/searchBlankSX.js";

import {motion} from 'framer-motion'

import { Button, ToggleButtonGroup, ToggleButton } from "@mui/material/";

const Filter = ({
  setFiltered,
  firedata,
  toggleFilter,
  handleHomeSearch,
  handleResultsSearch,
  handleFilterToggle,
  displayClose,
  isOpen,
  setIsOpen,
  routeHome
}) => {
  // Name Search Autocomplete
  const [expertChoice, setExpertChoice] = useState(undefined);
  const [skillsChoice, setSkillsChoice] = useState(undefined);
  const [experienceChoice, setExperienceChoice] = useState(undefined);

  

  // UseEffect Filter Function Call
  useEffect(() => {
    const results = firedata.filter(
      (item) =>
        item.data.mentorType == "Mentor" &&
        item.data.expLevel == experienceChoice &&
        item.data.expertise == expertChoice &&
        item.data.skills.some((item) => skillsChoice.includes(item))
    );

    setExpertChoice(undefined);
    setSkillsChoice(undefined);
    setExperienceChoice(undefined);
    // setIsOpen(!isOpen);
    setFiltered(results);
  }, [toggleFilter]);

  const handleExperienceChoice = (e, updated) => {
    if (updated !== null) {
      setExperienceChoice(updated);
    }
  };
  const handleExpertChoice = (e, updated) => {
    if (updated !== null) {
      setExpertChoice(updated);
    }
  };
  const handleSkillsChoice = (e, updated) => {
    if (updated !== null) {
      setSkillsChoice(updated);
    }
  };

  const buttonSX = {
    backgroundColor: "#FFF",
    textTransform: "none",
    borderRadius: "16px",
    border: "3px solid #348F1B",
    color: "#000",
    "&:hover": {
      fill: "#CEE1C9",
    },
  };

  return (

    <nav 
    style={routeHome === false ?
    {backgroundColor: "white"}
  : null}
    className="filter">
      <div className="wrapper">
        {routeHome ? (null): 
        <p 
            onClick={handleFilterToggle}
        // sx={buttonSX}
        className="button closeButton"
        variant="contained">
        <span className="closeIcon">
          <img src={closeIcon} alt="close button icon" /> 
        </span>
      </p>
        }
        
        <div className="top">
          <div className="topLeft">
            <div className="subCat ">
              <h3>Browse mentors by area of expertise</h3>
              <ToggleButtonGroup
                sx={{ justifyContent: "flex-start", display: "flex" }}
                exclusive
                value={expertChoice}
                onChange={handleExpertChoice}
                className="toggleBox profession"
              >
                {/* rendering our array of expert types */}
                {formInputs.expertise.map((item) => (
                  <ToggleButton
                    className="toggles"
                    sx={expertiseSX}
                    key={item.id}
                    value={item.name}
                  >
                    {item.name}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </div>
            <div className="subCat ">
              <h3>Browse mentors by experience level</h3>
              <ToggleButtonGroup
                sx={{ justifyContent: "flex-start", display: "flex" }}
                exclusive
                value={experienceChoice}
                onChange={handleExperienceChoice}
                className="toggleBox experience"
              >
                {/* rendering our array of experience level types */}
                {formInputs.experience.map((item) => (
                  <ToggleButton
                    className="toggles"
                    sx={expertiseSX}
                    key={item.id}
                    value={item.name}
                  >
                    {item.name}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </div>
          </div>
          <div className="topRight">
            <div className="subCat ">
              <h3>Browse mentors by skill</h3>
              <ToggleButtonGroup
                sx={{ justifyContent: "flex-start", display: "flex" }}
                exclusive
                value={skillsChoice}
                onChange={handleSkillsChoice}
                className="toggleBox skills"
              >
                {/* rendering our array of skills types */}
                   {formInputs.skills.map((item) => (
                  <ToggleButton
                    className="toggles"
                    sx={expertiseSX}
                    key={item.id}
                    value={item.name}
                  >
                    {item.name}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </div>
          </div>
        </div>

        <div className="bottom">
          <Button
          sx={searchSX}
            // sx={expertChoice === undefined ? searchBlankSX : searchSX}
            onClick={routeHome ? handleHomeSearch : handleResultsSearch}
            className="button filter"
            variant="contained"
          >
            Search
          </Button>
        </div>
      </div>
    </nav>


// ----------------------------
    // <motion.nav
    // animate={{
    //         backgroundColor: isOpen ? "white" : "none",
    //         transition: {
    //           duration: 1,
    //           type: "easeInOut",
    //           damping: 10,
    //         },
    //       }}
      
    //   className="filter"
    // >
    //   <div className="wrapper">
    //     {displayClose === false ? (null): 
    //     // <p className="closeButton" onClick={() => closeFilter(false)}>X</p>
    //     <Button 
    //     onClick={() => closeFilter(false)}
    //     sx={buttonSX}
    //     className="button closeButton"
    //     variant="contained">
    //     <span className="closeIcon">
    //       <img src={closeIcon} alt="close button icon" /> 
    //     </span>
    //   </Button>
    //     }

    //     <div className="top">
    //       <div className="topLeft">
    //         <div className="subCat ">
    //           <h3>Browse mentors by area of expertise</h3>
    //           <ToggleButtonGroup
    //             sx={{ justifyContent: "flex-start", display: "flex" }}
    //             exclusive
    //             value={expertChoice}
    //             onChange={handleExpertChoice}
    //             className="toggleBox profession"
    //           >
    //             {/* rendering our array of expert types */}
    //             {formInputs.expertise.map((item) => (
    //               <ToggleButton
    //                 className="toggles"
    //                 sx={expertiseSX}
    //                 key={item.id}
    //                 value={item.name}
    //               >
    //                 {item.name}
    //               </ToggleButton>
    //             ))}
    //           </ToggleButtonGroup>
    //         </div>
    //         <div className="subCat ">
    //           <h3>Browse mentors by experience level</h3>
    //           <ToggleButtonGroup
    //             sx={{ justifyContent: "flex-start", display: "flex" }}
    //             exclusive
    //             value={experienceChoice}
    //             onChange={handleExperienceChoice}
    //             className="toggleBox experience"
    //           >
    //             {/* rendering our array of experience level types */}
    //             {formInputs.experience.map((item) => (
    //               <ToggleButton
    //                 className="toggles"
    //                 sx={expertiseSX}
    //                 key={item.id}
    //                 value={item.name}
    //               >
    //                 {item.name}
    //               </ToggleButton>
    //             ))}
    //           </ToggleButtonGroup>
    //         </div>
    //       </div>
    //       <div className="topRight">
    //         <div className="subCat ">
    //           <h3>Browse mentors by skill</h3>
    //           <ToggleButtonGroup
    //             sx={{ justifyContent: "flex-start", display: "flex" }}
    //             exclusive
    //             value={skillsChoice}
    //             onChange={handleSkillsChoice}
    //             className="toggleBox skills"
    //           >
    //             {/* rendering our array of skills types */}
    //             {formInputs.skills.map((item) => (
    //               <ToggleButton
    //                 className="toggles"
    //                 sx={expertiseSX}
    //                 key={item.id}
    //                 value={item.name}
    //               >
    //                 {item.name}
    //               </ToggleButton>
    //             ))}
    //           </ToggleButtonGroup>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="bottom">
    //       <Button
    //         sx={searchSX}
    //         onClick={handleSearch}
    //         className="button filter"
    //         variant="contained"
    //       >
    //         Search
    //       </Button>
    //     </div>
    //   </div>
    // </motion.nav>
  );
};

export default Filter;
